import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=47e155ad"
import script from "./periodical.vue?vue&type=script&lang=js"
export * from "./periodical.vue?vue&type=script&lang=js"
import style0 from "./periodical.vue?vue&type=style&index=0&id=47e155ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports